"use client";
import { IBlocks, IBlog, IBlogPost, IUserData } from "@/types";
import React from "react";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import { BlogPostSkeletonBlock } from "@/components/admin/blog/skeleton";
import PostList from "@/components/admin/blog/PostList";
import BlockClickHandler from "./utils/click";
import { cn } from "@/lib/utils";
import {
    BORDER_RADIUS_OPTIONS,
    SHADOW_OPTIONS,
} from "./utils/block-style-classes";
interface Props {
    edit?: boolean;
    account: IUserData;
    block: IBlocks;
    update?: BlockUpdateFunction;
    theme: IUserData["chosen_theme"];
}
export default function BlockBlogPostLatest({
    edit,
    account,
    block,
    update,
    theme,
}: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    const [blog, setBlog] = React.useState<IBlog | null>(null);
    const [posts, setPosts] = React.useState<IBlogPost[] | null>(null);
    const [isLoading, setIsLoading] = React.useState(true);
    React.useEffect(() => {
        async function getPost() {
            const res = await fetch(
                `/api/account/${account.id}/latest-post${blockUpdate.options?.limit ? `?limit=${blockUpdate.options?.limit}` : ""}`
            );
            const post = await res.json();
            if (post.data) {
                setPosts(post.data.posts);
                setBlog(post.data.blog);
                setIsLoading(false);
            }
        }
        getPost();
    }, [blockUpdate.options?.limit, account.id]);
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={"Blog Post Latest"}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <div
                key={block.id}
                className={cn(
                    `relative flex w-full flex-row flex-wrap gap-2 p-2`,
                    BORDER_RADIUS_OPTIONS[theme.profile.design.corner_radius]
                        ?.class,
                    SHADOW_OPTIONS[theme.profile.design.shadow]?.class,
                    "block-" + block.id
                )}
                id="BlogPostLatest"
                onClick={(e) => {
                    BlockClickHandler(account, e, block);
                }}
                onAuxClick={(e) => {
                    BlockClickHandler(account, e, block);
                }}
            >
                <p className="text-lg font-bold text-user-primary-text-color">
                    {blockUpdate?.options?.name}
                </p>

                {isLoading && <BlogPostSkeletonBlock account={account} />}
                {!isLoading &&
                    blog &&
                    posts &&
                    posts.map((post, index) => (
                        <PostList
                            key={index}
                            blog={blog}
                            assets={[]}
                            post={{
                                ...post,
                                category_name:
                                    blog.categories.find(
                                        (e) => e.id == post.category
                                    )?.name || "",
                            }}
                            account={account}
                            accountTheme={{
                                ...account.theme,
                                text_col_button:
                                    theme.profile.colors.primary_text,
                                button: theme.profile.colors.primary,
                            }}
                            v2Theme={theme.profile as any}
                        />
                    ))}
            </div>
        </AdminPopover>
    );
}
